var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmIcon = function SvgConfirmIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.282 5.059c.535.416.631 1.187.215 1.722l-3.82 4.909a1.227 1.227 0 0 1-1.813.136L4.137 9.234a1.227 1.227 0 1 1 1.692-1.78l1.744 1.66 2.987-3.84a1.227 1.227 0 0 1 1.722-.215"
  })));
};
export default SvgConfirmIcon;